
import btn from '../components/btn'
export default {
    name: 'SubmitInfo',
    components: {
        btn
    },
    props: {
        content: {
            type: Object,
            default: () => ({})
        },
        canSeeBtns: {
            type: Boolean,
            default: false
        },
        mentionedUser: {
            type: String,
            default: ''
        },
        displayData: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            isShow: false,
            isSubmitted: false,
            isLoading: false,
            formData: {
                uid: '',
                account: '',
                password: ''
            },
            formRules: {
                uid: [
                    { required: true, message: '请输入UID', trigger: 'blur' },
                    { min: 3, max: 20, message: 'UID长度在3到20个字符', trigger: 'blur' }
                ],
                account: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    { min: 3, max: 30, message: '账号长度在3到30个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在6到20个字符', trigger: 'blur' }
                ]
            },
            accountData: {
                gameIcon: 'https://oss.yingbowl.com/c/2/goods/detail/20250304/1896734510009511936/PZ_ADMIN_67c65749e4b0319405da3569.png',
                accountId: 'C1WHJD号',
                description: '贵族5 珍品传说3 传说皮肤4 史诗皮肤3 皮肤...',
                amount: '1000',
                gameName: '和平精英',
                gameServer: '安卓QQ'
            }
        }
    },
    created () { },
    methods: {
        handleSubmitForm () {
            this.$refs.submitForm.validate(valid => {
                if (valid) {
                    this.isLoading = true
                    // 模拟提交过程
                    setTimeout(() => {
                        this.isLoading = false
                        this.isSubmitted = true
                        this.$emit('submit')
                    }, 1000)
                }
            })
        }
    }
}
